export namespace ProductModels {

	/**
	 * 產品應用Model
	 */
	export class ProductApplicationField {
		id: number;
		created_at: Date;
		updated_at: Date;
		deleted_at: Date;
		name: string;
	
		constructor(
			id: number,
			created_at: Date,
			updated_at: Date,
			deleted_at: Date,
			name: string
		) {
			this.id = id;
			this.created_at = created_at;
			this.updated_at = updated_at;
			this.deleted_at = deleted_at;
			this.name = name;
		}
	}

	/**
	 * 產品相關報告Model
	 */
	export class ProductReport {
		id: number;
		created_at: Date;
		updated_at: Date;
		deleted_at: Date;
		name: string;
		file_name: string;
		file: string | null;
	
		constructor(
			id: number,
			created_at: Date,
			updated_at: Date,
			deleted_at: Date,
			name: string,
			file_name: string,
			file: string | null = null
		) {
			this.id = id;
			this.created_at = created_at;
			this.updated_at = updated_at;
			this.deleted_at = deleted_at;
			this.name = name;
			this.file_name = file_name;
			this.file = file;
		}
	}


	/**
	 * 產品特性Model
	 */
	export class ProductFeature {
		thermal_conductivity: number;
		temperature_min: number;
		temperature_max: number;
		thickness_min: number;
		thickness_max: number;
		hardness_str: string;
		hardness_thin_C: number;
		hardness_tolerance_C: number;
		hardness_thick_C: number;
		hardness_thin_00: number;
		hardness_tolerance_00: number;
		linkage: Record<string, Record<string, number>>;
		hardness_thick_00: number;
		volatile_component: number;
		volatile_temperature: number;
		volatile_hour: number;
		color: string;
		memo: string;
	
		constructor(
			thermal_conductivity: number,
			temperature_min: number,
			temperature_max: number,
			thickness_min: number,
			thickness_max: number,
			hardness_str: string,
			hardness_thin_C: number,
			hardness_tolerance_C: number,
			hardness_thick_C: number,
			hardness_thin_00: number,
			hardness_tolerance_00: number,
			hardness_thick_00: number,
			linkage: Record<string, Record<string, number>>,
			volatile_component: number,
			volatile_temperature: number,
			volatile_hour: number,
			color: string,
			memo: string
		) {
			this.thermal_conductivity = thermal_conductivity;
			this.temperature_min = temperature_min;
			this.temperature_max = temperature_max;
			this.thickness_min = thickness_min;
			this.thickness_max = thickness_max;
			this.hardness_str = hardness_str;
			this.hardness_thin_C = hardness_thin_C;
			this.hardness_tolerance_C = hardness_tolerance_C;
			this.hardness_thick_C = hardness_thick_C;
			this.hardness_thin_00 = hardness_thin_00;
			this.hardness_tolerance_00 = hardness_tolerance_00;
			this.hardness_thick_00 = hardness_thick_00;
			this.linkage = linkage;
			this.volatile_component = volatile_component;
			this.volatile_temperature = volatile_temperature;
			this.volatile_hour = volatile_hour;
			this.color = color;
			this.memo = memo;
		}
	}
	

  	/**
	 * 產品Model
	 */
	export interface Product {
		id: number;
		type: number;
		product_number: string;
		description: string;
		application: string;
		intro: string;
		language_type: number;
		image: string | null;
		image_path: string | null;
		feature_from: string | null;
		feature_from_path: string | null;
		features: ProductFeature | null;
		reports: ProductReport[];
		application_field: ProductApplicationField[];
	}
	// export class Product {
	// 	id: number;
	// 	created_at: Date;
	// 	updated_at: Date;
	// 	deleted_at: Date;
	// 	type: number;
	// 	product_number: string;
	// 	description: string;
	// 	application: string;
	// 	intro: string;
	// 	language_type: number;
	// 	image: string | null;
	// 	image_paht: string | null;
	// 	feature_from: string | null;
	// 	feature_from_path: string | null;
	// 	features: ProductFeature | null;
	// 	reports: ProductReport[];
	// 	application_field: ProductApplicationField[];

	// 	constructor(
	// 		id: number,
	// 		created_at: Date,
	// 		updated_at: Date,
	// 		deleted_at: Date,
	// 		type: number,
	// 		product_number: string,
	// 		description: string,
	// 		application: string,
	// 		intro: string,
	// 		language_type: number,
	// 		image: string | null = null,
	// 		feature_from: string | null = null,
	// 		image_paht: string | null = null,
	// 		feature_from_path: string | null = null,
	// 		features: ProductFeature | null = null,
	// 		reports: ProductReport[] = [],
	// 		application_field: ProductApplicationField[] = []
	// 	) {
	// 		this.id = id;
	// 		this.created_at = created_at;
	// 		this.updated_at = updated_at;
	// 		this.deleted_at = deleted_at;
	// 		this.type = type;
	// 		this.product_number = product_number;
	// 		this.description = description;
	// 		this.application = application;
	// 		this.intro = intro;
	// 		this.language_type = language_type;
	// 		this.image = image;
	// 		this.feature_from = feature_from;
	// 		this.features = features;
	// 		this.reports = reports;
	// 		this.application_field = application_field;
	// 	}
	// }

}
